import React, { useState } from 'react'
import "./Mints.css"
import { Link } from 'react-router-dom'
import "./Mint.css"
import { Row, Col } from "react-bootstrap"
import carousel4 from "../../Images/carousel4.jpg"
import Navbars from "../Navbars/Navbars"
import logo from "../../Images/logo1.png"
import carousel3 from "../../Images/carousel3.jpg"
import { formatCountdown } from 'antd/lib/statistic/utils'
import { BiUpArrow } from "react-icons/bi"
import { BiDownArrow } from "react-icons/bi"

function Mints() {

    const [counter, setCounter] = useState(1)

    const handleIncrement = () => {
        if (counter <= 4) {
            setCounter(counter + 1)
        }
        else {
            setCounter(counter)
        }


    }
    const handleDecrement = () => {
        if (counter > 1) {
            setCounter(counter - 1)
        }
        else {
            setCounter(counter)
        }
    };
    return (
        <>
            {/* <Navbars /><br /> */}
            <div className="container minto" >

                <div>

                    <div className="home_mainn">
                        <img src={logo} className="home_iner_imgg" />
                    </div>

                </div>

                {/* <div className="button_div">

                    <div className="caro_div">
                        <h2>couter</h2>
                        <img src={carousel3} className="img_car" />
                    </div>

                </div> */}
                <Row>
                    <Col xl={2} lg={2} md={6} sm={12} xs={12} className="col_oneee"></Col>
                    <Col xl={2} lg={2} md={6} sm={12} xs={12} className="icon_column">


                        <BiUpArrow className="arrow_icon" onClick={handleIncrement} /><br />
                        <div className="run">
                            <p className="p-counter">{counter}</p>
                        </div><br />
                        <BiDownArrow className="arrow_icon" onClick={handleDecrement} />
                    </Col>
                    <Col xl={4} lg={4} md={6} sm={12} xs={12} className="col_th">
                        <div >

                            <img src={carousel3} className="img_car" />
                        </div>
                    </Col>
                    <Col xl={4} lg={4} md={6} sm={12} xs={12} className="col_oneee"></Col>

                </Row>
                <div className="carossy">
                    <Link to="/" target="./blank" className="linkedsy">


                        <div className="story_discordsy mintss">
                            <p className="story_joinsy">Mint</p>
                        </div></Link>
                    <br /><br />


                    <h4>Balance: 10 Sol</h4>
                    <h4 className="address">Address: 3GC7h 75Tq</h4>






                </div>

            </div>




        </>
    )
}

export default Mints
